import {isLoggedIn} from '@github-ui/client-env'
import {dismissOrganizationNoticePath} from '@github-ui/paths'
import {reactFetch} from '@github-ui/verified-fetch'
import {useCallback} from 'react'

export function useDismissOrgNotice(noticeName: string, orgName: string, orgId: string) {
  const dismissNotice = useCallback(async () => {
    // Only signed-in viewers can persist a dismissal; signed-out clicks are a no-op
    // and must not remove the banner.
    if (!isLoggedIn()) return false

    const form = new FormData()
    form.append('_method', 'delete')
    form.append('input[notice]', noticeName)
    form.append('input[organizationId]', orgId)
    form.append('input[forWholeOrg]', 'false')

    const response = await reactFetch(dismissOrganizationNoticePath({org: orgName}), {
      method: 'DELETE',
      body: form,
    })

    if (!response.ok) {
      throw new Error(`Failed to dismiss "${noticeName}" org notice: ${response.status} ${response.statusText}`)
    }

    // The notice was dismissed server-side, so the banner should now be removed.
    return true
  }, [noticeName, orgName, orgId])

  return {dismissNotice}
}

export function useDismissRepositoryNotice(noticeName: string, dismissUrl: string, repositoryId: number) {
  const dismissNotice = useCallback(async () => {
    if (!isLoggedIn()) return false

    const form = new FormData()
    form.append('notice_name', noticeName)
    form.append('repository_id', String(repositoryId))

    const response = await reactFetch(dismissUrl, {
      method: 'DELETE',
      body: form,
    })

    if (!response.ok) {
      throw new Error(`Failed to dismiss "${noticeName}" repository notice: ${response.status} ${response.statusText}`)
    }

    return true
  }, [dismissUrl, noticeName, repositoryId])

  return {dismissNotice}
}
